import { render } from "./Fail.vue?vue&type=template&id=6224d921&ts=true"
import script from "./Fail.vue?vue&type=script&lang=ts"
export * from "./Fail.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.0_vue@3.5.0_typescript@4.7.4__webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__